module.exports = "pegasus_template/assets/theme6/small/6.jpg";